import {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
} from "./chunk-H42UHNAG.js";
export {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
};
